<template>
  <div class="footer">
    <!-- 友情链接 -->
    <div class="box-center cf">
      <!-- 首页友情链接 -->
      <template v-if="footerOptions.isHome !== undefined">
        <div class="friend-link">
          <em>
            <a class="yuewen" href="//www.yuewen.com" target="_blank">
              阅文集团
            </a>
            <cite>旗下网站：</cite>
          </em>
          <a :href="`//${domainPrefix}www.qidian.com/`">起点中文网</a>
          <a href="//book.qq.com" target="_blank">QQ阅读</a>
          <a href="http://yuedu.yuewen.com" target="_blank">阅文悦读</a>
          <a :href="`//${domainPrefix}www.qidian.com/booklist/`">书单</a>
          <a :href="`//${domainPrefix}www.qidian.com/ziyuan`">起点资源站</a>
          <a :href="`//${domainPrefix}www.qidian.com/recommendbooklist/`"></a>
          <a :href="`//${domainPrefix}www.qidian.com/ask`"></a>
        </div>
      </template>

      <!-- 其他页面友情链接 -->
      <template
        v-else-if="
          footerOptions.friendlinks && footerOptions.friendlinks.length
        "
      >
        <div class="friend-link">
          <a
            v-for="(link, index) in footerOptions.friendlinks"
            :key="index"
            :href="link.url"
            :title="link.title"
            target="_blank"
          >
            {{ link.title }}
          </a>
        </div>
      </template>

      <!-- 页脚菜单 -->
      <div class="footer-menu dib-wrap">
        <a
          :href="`//${domainPrefix}www.qidian.com/about/intro`"
          target="_blank"
        >
          关于起点
        </a>
        <a
          :href="`//${domainPrefix}www.qidian.com/about/contact`"
          target="_blank"
        >
          联系我们
        </a>
        <a href="//join.yuewen.com" rel="nofollow" target="_blank">加入我们</a>
        <a :href="`//${domainPrefix}www.qidian.com/help`" target="_blank">
          帮助与客服
        </a>
        <a href="//jubao.yuewen.com" rel="nofollow" target="_blank">举报中心</a>
        <a href="//security.tencent.com/" rel="nofollow" target="_blank">
          漏洞提交
        </a>
      </div>

      <!-- 版权信息 -->
      <div class="copy-right">
        <p>copyright &copy; 2002-{{ currentYear }} {{ pcDomain }}</p>
        <p>增值电信业务经营许可证：沪B2-20080046</p>
        <p>
          网站备案/许可证号：
          <a href="http://beian.miit.gov.cn">{{ icpFiling }}</a>
          &nbsp;&nbsp;
          <a
            target="_blank"
            href="https://imgservices-1252317822.image.myqcloud.com/coco/s11062023/655b2b94.f2jl6x.png"
          >
            <span>互联网宗教信息服务许可证 编号：沪（2022）0000022</span>
          </a>
        </p>
      </div>

      <!-- 安全中心 -->
      <template
        v-if="
          footerOptions.navHighLight !== undefined &&
          footerOptions.navHighLight === 0
        "
      >
        <div class="safety-box">
          <div class="safety-img dib-wrap">
            <a
              class="site3"
              href="http://cyberpolice.mps.gov.cn/wfjb"
              target="_blank"
            ></a>
            <a
              class="site4"
              href="https://ss.knet.cn/verifyseal.dll?sn=e18013031011571840mt51000000&pa=111332"
              target="_blank"
            ></a>
            <a class="site6" href="http://www.12377.cn/" target="_blank"></a>
            <a class="site5" href="http://www.shjbzx.cn" target="_blank"></a>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { usePageContext } from '@share/ssr/usePageContext'
import { getIcpFilingByHost } from '@share/common/siteConfig'
import { IFooterOptions } from './type'

defineProps({
  footerOptions: {
    type: Object as PropType<IFooterOptions>,
    default: () => {
      return {}
    },
  },
})

const domainPrefix =
  import.meta.env.VITE_ENV_TYPE === 'pro' ? '' : import.meta.env.VITE_ENV_TYPE

// 计算当前年份
const currentYear = computed(() => new Date().getFullYear())

// 当前 host 对应的「互联网 ICP 备案号」（按站点动态展示）
// 浏览器侧 SSR 注入失败时退回 location.hostname；都拿不到则保留兜底文案 `沪B2-20080046-1`
const pageContext = usePageContext<unknown, unknown>()
const { pcDomain } = pageContext
const icpFiling = computed<string>(() => {
  const host =
    (pageContext as { hostname?: string })?.hostname ||
    (typeof window !== 'undefined' ? window.location.hostname : '') ||
    ''
  return getIcpFilingByHost(host) || '沪B2-20080046-1'
})
</script>

<style lang="scss" scoped>
@import '../../assets/scss/global.scss';
@import '../../assets/scss/mixin.scss';
.footer {
  background: #fafafa;
  text-align: center;
  .box-center {
    background: #fafafa;
  }
  .footer-text {
    padding: 20px 26px 0;
    p {
      text-align: left;
      color: #1a1a1a;
      font-size: 12px;
      line-height: 20px;
      font-family: $simsun;
    }
  }
  .friend-link {
    padding-top: 20px;
    padding-bottom: 2px;
    overflow: hidden;
    font-size: 0;
    em,
    a,
    cite {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
    }
    em {
      margin-right: 8px;
      font-family: $simsun;
    }
  }
  .friend-link,
  .footer-menu {
    em {
      color: #1a1a1a;
    }
    a {
      margin-right: 16px;
      font-size: 12px;
      font-family: $simsun;
      line-height: 27px;
      color: #1a1a1a;
      &:hover {
        color: $hover;
      }
      &.yuewen {
        margin-right: 0;
      }
    }
  }
  .footer-menu {
    padding: 12px 0 4px;
    a {
      color: $gray6;
    }
  }
  .copy-right {
    padding-bottom: 16px;
    a,
    img {
      display: inline-block;
      vertical-align: middle;
    }
    a {
      height: 20px;
      line-height: 20px;
      font-family: Arial;
      margin-right: 5px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
      margin-top: -2px;
    }
  }
  .copy-right,
  .safety-box {
    p {
      height: 20px;
      font: 12px/20px $simsun;
      color: $A6;
      overflow: hidden;
      a {
        color: $A6;
        &:hover {
          color: $red;
        }
      }
    }
    span {
      margin-right: 5px;
      font-family: Arial;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .safety-img {
    padding: 0 0 16px;
    a {
      width: 140px;
      height: 52px;
      margin-right: 14px;
      background-image: url(~@images/foot_site.png?max_age=31536000);
      @include border(#ededed);
      &.site1 {
        background-position: 0 0;
      }
      &.site2 {
        background-position: 0 -52px;
      }
      &.site3 {
        background-position: 0 -104px;
      }
      &.site4 {
        background-position: 0 -156px;
      }
      &.site5 {
        background-position: 0 -208px;
      }
      &.site6 {
        background-position: 0 -260px;
      }
      &.site7 {
        background-position: 0 -312px;
      }
    }
  }
}
/* inline-block 去除元素之间空隙 */
.dib-wrap {
  font-size: 0;
  *word-spacing: -1px;
  a,
  span {
    display: inline-block;
    vertical-align: middle;
    letter-spacing: normal;
    word-spacing: normal;
  }
}
@media (max-width: 1280px) {
  .footer .safety-img a {
    margin-right: 8px;
    width: 130px;
    height: 50px;
  }
}
</style>
